import { FC } from 'react';

import {
  OnSortColumnType,
  ColumnType,
  Pagination,
} from '@dynamika-shared/ui/Table/Table.types';
import { AuditTrialType } from '@dynamika-shared/types/auditTrial';

import { Table } from '@dynamika-shared/ui/Table/Table';

const MODAL_HIGHLIGHT_DURATION_MS = 3_600_000;

export type AuditTrialColumnType = ColumnType<AuditTrialType>;

export type AuditTrialsListPageViewProps<T = AuditTrialType> = {
  loading?: boolean;
  auditTrialsData: AuditTrialType[];
  totalItems: number;
  onSort: OnSortColumnType;
  sortState?: string;
  pagination: Pagination;
  filteredTableColumns: AuditTrialColumnType[];
  onRowClick: (row: number | T, rowIndex: number) => void;
  shouldHighlightRow?: (row: number | T) => boolean | undefined;
};

export const AuditTrialsListPageView: FC<AuditTrialsListPageViewProps> = ({
  auditTrialsData,
  totalItems,
  loading,
  onSort,
  sortState,
  pagination,
  filteredTableColumns,
  onRowClick,
  shouldHighlightRow,
}) => {
  return (
    <div data-testid='Audit-Trial'>
      <div className='relative mt-1 h-[calc(100%-120px)]'>
        <Table
          styles={{
            table: 'w-auto min-w-full table-auto',
            headerCell: 'whitespace-nowrap',
          }}
          columns={filteredTableColumns}
          data={auditTrialsData}
          totalItems={totalItems}
          loading={loading}
          onSort={onSort}
          sortState={sortState}
          pagination={pagination}
          pageSizeOptions={[10, 20, 50, 100]}
          onRowClick={onRowClick}
          shouldHighlightRow={shouldHighlightRow}
          highlightDuration={MODAL_HIGHLIGHT_DURATION_MS}
        />
      </div>
    </div>
  );
};
